<template>
  <div>
    <div v-if="$userInfo"
      class="tile is-parent">
      <article class="tile is-child box">
        <div class="columns is-flex is-align-items-center">
          <div class="column">
            <p class="title">Error Log Detail</p>
          </div>
        </div>
        <div class="field-body is-justify-content-center">
          <div v-if="innerValue"
            class="box">
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Event ID</label>
                  <div class="control">
                    <span>{{ innerValue.eventId || 'N/A' }}</span>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="field">
                  <label class="label">Created Date</label>
                  <div class="control">
                    <span>{{ formatDate(innerValue.createdDate) }}</span>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Company</label>
                  <div class="control">
                    <span>{{ innerValue.company || 'N/A' }}</span>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="field">
                  <label class="label">User</label>
                  <div class="control">
                    <span>{{ innerValue.user || 'N/A' }}</span>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <div class="field">
                  <label class="label">Page URL</label>
                  <div class="control">
                    <span class="url-text">{{ innerValue.pageUrl || 'N/A' }}</span>
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <div class="field">
                  <label class="label">Call Site</label>
                  <div class="control">
                    <span class="url-text">{{ innerValue.referrerUrl || 'N/A' }}</span>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <div class="field">
                  <label class="label">Message</label>
                  <div class="control">
                    <div class="message-text">{{ innerValue.message || 'N/A' }}</div>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <div class="field">
                  <label class="label">Exception</label>
                  <div class="control">
                    <div class="json-text">{{ parsedMessage.innerException || parsedMessage.exception }}</div>
                  </div>
                </div>
              </div>

              <div class="column is-full">
                <div class="field">
                  <label class="label">Stack Trace</label>
                  <div class="control">
                    <div class="json-text">{{ parsedMessage.innerStackTrace || parsedMessage.stackTrace }}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="box"
            v-else>
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <span icon="icon is-large">
                  <span class="mso mso-fill mso-40px">sentiment_dissatisfied</span>
                </span>
                <p>Nothing</p>
              </div>
            </section>
          </div>
        </div>
      </article>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ErrorLogDetail',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      innerValue: {},
      isModelActive: false,
      loading: false,
      innerException: '',
      innerStackTrace: '',
      parsedMessage: {
        timeStamp: '',
        innerExceptionType: '',
        innerStackTrace: '',
        innerSource: '',
        innerStackTrace: '',
        exceptionType: '',
        exception: '',
        source: '',
        stackTrace: ''
      }
    }
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.innerValue = newVal
        if (newVal && newVal.fullMessage) {
          this.parseError(newVal.fullMessage)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.innerValue = this.value
  },
  methods: {
    isJson(str) {
      if (typeof str !== 'string') return false
      try {
        const parsed = JSON.parse(str)
        return parsed && typeof parsed === 'object'
      } catch (e) {
        return false
      }
    },
    parseError(stringData) {
      if (!stringData) return
      const isJson = this.isJson(stringData)
      if (isJson) {
        let parsedJson = {}
        try {
          parsedJson = JSON.parse(stringData)
        } catch (e) {
          console.error('Invalid JSON', e)
        }
        this.parsedMessage = {
          timeStamp: parsedJson.TimeStamp || '',
          innerExceptionType: parsedJson.UniqInnerException.InnerExceptionType || '',
          innerException: parsedJson.UniqInnerException.InnerException || '',
          innerSource: parsedJson.UniqInnerException.InnerSource || '',
          innerStackTrace: parsedJson.UniqInnerException.InnerStackTrace || '',
          exceptionType: parsedJson.ExceptionType || '',
          exception: parsedJson.Exception || '',
          source: parsedJson.Source || '',
          stackTrace: parsedJson.StackTrace || ''
        }
      } else {
        this.parsedMessage = {
          timeStamp: this.getTagValue(stringData, 'TimeStamp'),
          innerExceptionType: this.getTagValue(stringData, 'InnerExceptionType'),
          innerException: this.getTagValue(stringData, 'InnerException'),
          innerSource: this.getTagValue(stringData, 'InnerSource'),
          innerStackTrace: this.getTagValue(stringData, 'InnerStackTrace'),
          exceptionType: this.getTagValue(stringData, 'ExceptionType'),
          exception: this.getTagValue(stringData, 'Exception'),
          source: this.getTagValue(stringData, 'Source'),
          stackTrace: this.getTagValue(stringData, 'StackTrace')
        }
      }
      if (!this.parsedMessage.innerException && !this.parsedMessage.exception) {
        this.parsedMessage.innerException = stringData
      }
    },
    getTagValue(xml, tag) {
      const regex = new RegExp(`<${tag}>([\\s\\S]*?)<\\/${tag}>`, 'i')
      const match = xml.match(regex)
      return match ? match[1].trim() : ''
    },
    formatDate(date) {
      if (!date) return 'N/A'
      return this.$filters.formatDateTimeLocale(date, this.$userInfo.locale)
    },
    hanldeClose() {
      this.isModelActive = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.message-text {
  white-space: pre-wrap;
}
.json-text {
  white-space: pre-wrap;
}
.url-text {
  white-space: pre-wrap;
}
</style>